//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import access from "config/access";
import { toast } from "react-toastify";
import * as moment from "moment";
import { parseISO } from "date-fns";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import { CSVLink } from "react-csv";
import { useHistory } from "react-router-dom";

// custom pages
import Table from "components/Table/Table";
import UnconsentedMemberAccountsAPI from "apis/unconsentedMemberAccounts/unconsentedMemberAccounts";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import useDebounce from "helpers/useDebounce";
import { blockInvalidCharForText } from "helpers/blockInvalidCharForText";
import CircularProgress from "@material-ui/core/CircularProgress";
import AuditAPI from "apis/audit/audit";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";
import { exportHeaders } from "./export";

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import MenuItem from "@material-ui/core/MenuItem";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import EditIcon from "@material-ui/icons/Edit";
import { isBefore } from "date-fns";
import HistoryIcon from "@material-ui/icons/History";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#2F7CBD",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#2F7CBD",
      border: "6px solid #2F7CBD",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid gray`,
    backgroundColor: "gray",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function UnconsentedMemberAccounts() {
  const {
    getAPI,
    searchAPI,
    getReasonDescriptionAPI,
    extendDeactiveDateAPI,
    filterAPI,
    exportAPI,
  } = UnconsentedMemberAccountsAPI();
  const { getAudit } = AuditAPI();
  const { state, dispatch } = useContext(Context);
  const classes = Styles();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  let searchBounceValues = useDebounce(() => {
    return searchValue === "" ? "" : searchValue;
  });

  // Extend Deactivation Date
  const [extendDeactivationObj, setExtendDeactivationObj] = useState({
    index: 0,
    loyaltyDetails: {},
    modal: false,
    updateReason: "",
    otherReason: false,
    extendDeactiveDate: moment(new Date()).format("YYYY-MM-DD"),
    type: "",
  });

  //Filter
  const [filterObj, setFilterObj] = useState({
    filterCard: false,
    extendedStartDate: null,
    extendedEndDate: null,
    extended: null,
    unconsentedPeriod: null,
    filterActive: false,
  });

  // Export Data
  const [exportData, setExportData] = useState([]);

  // Common State Object
  const [states, setstates] = useState({
    reasonDescription: [],
    clearSearch: false,
    historyDialog: false,
    historyLoader: false,
    filterCard: false,
    exportLoader:false
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { reasonDescription, clearSearch, historyDialog, historyLoader, exportLoader } =
    states;

  // Page Path Name
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "MEMBER DETAILS"],
    });
    handleGetReason();
  }, []);

  // Get Reasons API
  const handleGetReason = async () => {
    try {
      let res = await getReasonDescriptionAPI();
      if (res) {
        setStates({ reasonDescription: res.data });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // Handling Get and Search API
  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      } else if (filterObj?.filterActive) {
        handleFilter();
      } else {
         getDetails();
      }
    } else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset]);

  // Get API Func
  async function getDetails() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  }

  // Search API Func
  async function handleSearch() {
    setFilterObj({
      filterCard: false,
      extendedStartDate: null,
      extendedEndDate: null,
      extended: null,
      unconsentedPeriod: null,
      filterActive: false,
    });
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Data Table Headings
  let tableHeading = [
    "Member ID",
    "Billto",
    "Enrollment / Transfer",
    "Account Created By",
    "Status",
    "Unconsented Days",
    "Extended Date",
    "Extend Deactivation",
    "History",
  ];

  // Table Pagination Func
  const handlePagination = (value) => {
    setOffset(value);
  };

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "la",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };

  // Extend Deactive Date API Func
  const handleExtendDeactiveDate = async () => {
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        loyaltyId: extendDeactivationObj?.loyaltyDetails?.loyalty_id,
        updateReason: extendDeactivationObj?.updateReason,
        type: extendDeactivationObj?.type,
      };

      if (
        extendDeactivationObj?.type === "DEACTIVE-SET" ||
        extendDeactivationObj?.type === "DEACTIVE-UPDATE"
      ) {
        values = {
          ...values,
          extendDeactiveDate: extendDeactivationObj?.extendDeactiveDate,
        };
      }
      let res = await extendDeactiveDateAPI(values);
      if (res) {
        let msg = "";
        if (extendDeactivationObj?.type === "DEACTIVE-SET") {
          msg = "Account Deactivation Date Extended Succcessfully";
        }
        if (extendDeactivationObj?.type === "DEACTIVE-UPDATE") {
          msg = "Account Deactivation Date changed Succcessfully";
        }
        if (extendDeactivationObj?.type === "DEACTIVE-CANCEL") {
          msg = "Account Extending Deactivation Cancelled";
        }
        toast.success(msg, {
          tostId: "update-success",
        });
        setExtendDeactivationObj({
          index: 0,
          loyaltyDetails: {},
          modal: false,
          updateReason: "",
          otherReason: false,
          extendDeactiveDate: moment(new Date()).format("YYYY-MM-DD"),
          type: "",
        });
        if (offset === 1) {
          getDetails();
        } else {
          setOffset(1);
        }
      }
    } catch (e) {
      console.log("errors");
    }
  };

  // filter api func
  const handleFilter = async () => {
    setSearchValue("");
    setFilterObj({ ...filterObj, filterActive: true });
    try {
      let values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      if (filterObj.extendedStartDate && filterObj.extendedEndDate) {
        values = {
          ...values,
          extendedStartDate: filterObj.extendedStartDate,
          extendedEndDate: filterObj.extendedEndDate,
        };
      }

      if (typeof filterObj.extended === "boolean") {
        values = { ...values, extended: filterObj.extended };
      }

      if (filterObj.unconsentedPeriod) {
        values = {
          ...values,
          unconsentedPeriod: parseInt(filterObj.unconsentedPeriod),
        };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await filterAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
      }
      setFilterObj({ ...filterObj, filterCard: false, filterActive: true });
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleExport() {
    try {
      let values = {};

      if (searchValue) {
        values = {
          ...values,
          search: searchValue,
        };
      }

      if (filterObj.extendedStartDate && filterObj.extendedEndDate) {
        values = {
          ...values,
          extendedStartDate: filterObj.extendedStartDate,
          extendedEndDate: filterObj.extendedEndDate,
        };
      }

      if (typeof filterObj.extended === "boolean") {
        values = { ...values, extended: filterObj.extended };
      }

      if (filterObj.unconsentedPeriod) {
        values = {
          ...values,
          unconsentedPeriod: parseInt(filterObj.unconsentedPeriod),
        };
      }
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await exportAPI(values);
      if (res) {
        setExportData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
        return true;
      }
      return false;
    } catch (e) {
      console.log({ e });
    }
  }

  return (
    <Fragment>
      <div style={{ display: "flex", alignItems: "center" }}>
        <CssTextField
          id="search"
          placeholder="Search for Member ID or Billing ID"
          onKeyDown={blockInvalidChar}
          type={"number"}
              onWheel={(e) => e.target.blur()}
          variant="outlined"
          autoComplete="off"
          className={classes.searchInput}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 ? (
                  <CloseOutlinedIcon
                    className={classes.searchInputIcon}
                    onClick={() => {
                      setStates({ clearSearch: true });
                      setSearchValue("");
                      if (offset === 1) {
                        getDetails();
                      } else {
                        setOffset(1);
                      }
                    }}
                  />
                ) : (
                  <img
                    src={searchIcon}
                    alt=""
                    width="20px"
                    className={classes.searchInputIcon}
                  />
                )}
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => {
            e.target.value.replace(/\s+/g, "").length == 0
              ? setSearchValue("")
              : setSearchValue(e.target.value);
            setOffset(1);
            if (e.target.value.length == 0) {
              getDetails();
            }
          }}
          onClick={() => {}}
        />
        <Button
          className={`${classes.filterBtn} dash-1-filter-btn`}
          onClick={() => {
            setFilterObj({ ...filterObj, filterCard: !filterObj?.filterCard });
          }}
        >
          Filter
          {filterObj?.filterActive && (
            <Badge
              badgeContent={
                count == 0 ? null : filterObj?.filterActive && count
              }
              color="error"
              classes={{ badge: classes.badge }}
              max={999999}
              className={classes.badges}
            ></Badge>
          )}
        </Button>
        <Button
          className={`${classes.filterBtn} dash-1-filter-btn`}
          onClick={async () => {
            setStates({exportLoader:true})
            let res = await handleExport();
            if (res) {
              document.getElementById("csv").click();
              setStates({exportLoader:false})
            }
          }}
        >
          {exportLoader ? (
              <div style={{ marginLeft:"calc(50%)" }}>
                  <div class="dot-typing-e"></div>
              </div>
            ) :
              `Export`
            }
        </Button>
        <Button
          className={`${classes.deactivatedAccountsBtn} dash-1-filter-btn`}
          onClick={ () => {
            history.push("/dashboard/deactivated-member-accounts")
          }}
        >
          Deactivated Accounts
        </Button>
      </div>
      {filterObj?.filterCard && (
        <div className={classes.filterCardDiv}>
          <Grid container spacing={0}>
            <Grid item xs={12} style={{ float: "right" }}>
              <Card className={classes.filterCard}>
                <Grid
                  container
                  spacing={2}
                  className={classes.filterCardGridContainer}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={4}
                    className={classes.filterCardGrid}
                  >
                    <div className={classes.filterCardHeadText}>
                      Extended Date
                    </div>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disableToolbar
                            inputVariant="outlined"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="deactive-date"
                            className={classes.dateInput}
                            value={filterObj?.extendedStartDate}
                            minDate={new Date()}
                            onChange={(date) => {
                              let d = moment(date).format("YYYY-MM-DD");
                              setFilterObj({
                                ...filterObj,
                                extendedStartDate: d,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            autoOk
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                      <Grid item xs={6}>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            disableToolbar
                            inputVariant="outlined"
                            format="MM/dd/yyyy"
                            margin="normal"
                            id="deactive-date"
                            className={classes.dateInput}
                            value={filterObj?.extendedEndDate}
                            minDate={new Date()}
                            onChange={(date) => {
                              let d = moment(date).format("YYYY-MM-DD");
                              setFilterObj({
                                ...filterObj,
                                extendedEndDate: d,
                              });
                            }}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                            autoOk
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={2}
                    className={classes.filterCardGrid}
                  >
                    <div className={classes.filterCardHeadText}>Extended</div>
                    <TextField
                      select
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"text"}
                      autoComplete="off"
                      value={filterObj?.extended}
                      onChange={(e) => {
                        setFilterObj({
                          ...filterObj,
                          extended: e.target.value,
                        });
                      }}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </TextField>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={3}
                    className={classes.filterCardGrid}
                  >
                    <div className={classes.filterCardHeadText}>
                      Unconsented Accounts More than (Days)
                    </div>
                    <TextField
                      variant="outlined"
                      style={{ fontSize: "0.875rem !important", width: "100%" }}
                      type={"number"}
              onWheel={(e) => e.target.blur()}
                      autoComplete="off"
                      onKeyDown={blockInvalidChar}
                      value={filterObj?.unconsentedPeriod}
                      onChange={(e) => {
                        setFilterObj({
                          ...filterObj,
                          unconsentedPeriod: e.target.value,
                        });
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={3}
                    className={classes.filterCardBtnGrid}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Button
                          className={classes.filterCardApplyBtn}
                          onClick={() => {
                            if (
                              !filterObj.extendedStartDate &&
                              !filterObj.extendedEndDate &&
                              typeof filterObj.extended !== "boolean" &&
                              !filterObj.unconsentedPeriod
                            ) {
                              toast.error("Please select atleast one field.");
                              return;
                            }
                            if (
                              !states.extendedStartDate &&
                              states.extendedEndDate
                            ) {
                              toast.error("Please select extended start date");
                              return;
                            }
                            if (
                              states.extendedStartDate &&
                              !states.extendedEndDate
                            ) {
                              toast.error("Please select extended end date");
                              return;
                            }
                            handleFilter();
                            setCount(0);
                            setOffset(1);
                            // setResponse({ filter: false });
                          }}
                        >
                          Apply
                        </Button>
                      </Grid>
                      {filterObj?.filterActive && (
                        <Grid item xs={12}>
                          <Button
                            className={classes.filterCardResetBtn}
                            onClick={() => {
                              setFilterObj({
                                filterCard: false,
                                extendedStartDate: null,
                                extendedEndDate: null,
                                extended: null,
                                unconsentedPeriod: null,
                                filterActive: false,
                              });
                              if (offset === 1) {
                                getDetails();
                              } else {
                                setOffset(1);
                              }
                              setCount(0);
                            }}
                          >
                            Reset
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </div>
      )}
      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div>{i}</div>;
            })}
            data={
              data?.map((d, i) => [
                d?.loyalty_id,
                d?.customer_billto_account_number,
                d?.member_account_created_by === 1
                  ? "Enrollment"
                  : d?.member_account_created_by === 2
                  ? "Transfer"
                  : d?.member_account_created_by === 3
                  ? "Manual Enrollment"
                  : d?.member_account_created_by === 4
                  ? "Manual Transfer"
                  : "-",
                d?.request_by,
                d?.is_active ? (
                  <span className={classes.greenBtn}>Active</span>
                ) : (
                  <span className={classes.redBtn}>Deactive</span>
                ),
                d?.unconsented_days,
                d?.deactive_extended_date ? (
                  <span>
                    {moment(d?.deactive_extended_date).format("MM/DD/yyyy")}
                    &nbsp;
                    {!d?.account_disabled && (
                      <EditIcon
                        className={classes.editIcon}
                        onClick={() => {
                          setExtendDeactivationObj({
                            ...extendDeactivationObj,
                            index: i,
                            loyaltyDetails: d,
                            modal: true,
                            type: "DEACTIVE-UPDATE",
                            extendDeactiveDate: d?.deactive_extended_date,
                          });
                        }}
                      />
                    )}
                  </span>
                ) : (
                  "-"
                ),
                d?.account_disabled ? (
                  <div style={{ margin: 8 }}>-</div>
                ) : (
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={d?.extend_deactivation}
                        onChange={() => {
                          if (
                            access["editAccess"][state.userInfo?.role][
                              "member-details"
                            ]
                          ) {
                            if (d?.extend_deactivation) {
                              setExtendDeactivationObj({
                                ...extendDeactivationObj,
                                index: i,
                                loyaltyDetails: d,
                                modal: true,
                                type: "DEACTIVE-CANCEL",
                              });
                            } else {
                              setExtendDeactivationObj({
                                ...extendDeactivationObj,
                                index: i,
                                loyaltyDetails: d,
                                modal: true,
                                type: "DEACTIVE-SET",
                              });
                            }
                            setData([
                              ...data.slice(0, i),
                              {
                                ...data[i],
                                extend_deactivation: !d?.extend_deactivation,
                              },
                              ...data.slice(i + 1),
                            ]);
                            return;
                          } else {
                            toast.error(state.userInfo?.editAccess);
                            return;
                          }
                        }}
                        name=""
                      />
                    }
                  />
                ),
                state?.userInfo?.auditAccess && (
                  <HistoryIcon
                    style={{ cursor: "pointer", verticalAlign: "middle" }}
                    onClick={() => {
                      setStates({
                        historyDialog: true,
                        historyLoader: true,
                      });
                      handleGetHistoryData(d?.loyalty_id);
                    }}
                  />
                ),
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>Loading...</h2>
          </div>
        )}
      </div>

      {/* Extend Deactivation Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={extendDeactivationObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          <div className={classes.parentText}>Confirmation</div>
          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;
            {extendDeactivationObj?.type === "DEACTIVE-SET" ||
            extendDeactivationObj?.type === "DEACTIVE-UPDATE" ? (
              <span>
                The account will only be deactivated after the specified date by setting this member's extended deactivation.
              </span>
            ) : (
              <span>
                Cancelling will stop the extending deactivation period of <br />
                Member Account.
              </span>
            )}
          </div>
          <br />
          <Fragment>
            {(extendDeactivationObj?.type === "DEACTIVE-SET" ||
              extendDeactivationObj?.type === "DEACTIVE-UPDATE") && (
              <Fragment>
                <div className={classes.subParentText}>
                  Extend Deactivation Date&nbsp;
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format="MM/dd/yyyy"
                      margin="normal"
                      id="deactive-date"
                      className={classes.dateInput}
                      value={parseISO(
                        extendDeactivationObj?.extendDeactiveDate
                      )}
                      minDate={new Date()}
                      onChange={(date) => {
                        let d = moment(date).format("YYYY-MM-DD");
                        setExtendDeactivationObj({
                          ...extendDeactivationObj,
                          extendDeactiveDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Fragment>
            )}
            <div className={classes.subParentText}>
              Please choose the reason for updating&nbsp;
              <span style={{ color: "red" }}>*</span>
            </div>
            <div>
              <CssTextField
                variant="outlined"
                select
                fullWidth
                className={classes.dialogInput}
                value={
                  extendDeactivationObj?.otherReason
                    ? "Others"
                    : extendDeactivationObj?.updateReason
                }
                onChange={(e) => {
                  if (e.target.value === "Others") {
                    setExtendDeactivationObj({
                      ...extendDeactivationObj,
                      otherReason: true,
                      updateReason: "",
                    });
                  } else {
                    setExtendDeactivationObj({
                      ...extendDeactivationObj,
                      updateReason: e.target.value,
                      otherReason: false,
                    });
                  }
                }}
              >
                {[...reasonDescription, { reason_description: "Others" }]?.map(
                  (d, i) => (
                    <MenuItem value={d?.reason_description} key={i}>
                      {d?.reason_description}
                    </MenuItem>
                  )
                )}
              </CssTextField>

              {extendDeactivationObj?.otherReason && (
                <Fragment>
                  <div className={classes.subParentText}>
                    Type the Reason&nbsp;<span style={{ color: "red" }}>*</span>
                    &nbsp;
                    <span style={{ fontSize: 12 }}>(Max 120 Characters)</span>
                  </div>
                  <CssTextField
                    id="reason"
                    type={"text"}
                    autoComplete="off"
                    variant="outlined"
                    inputProps={{
                      maxLength: 120,
                    }}
                    className={classes.dialogInput}
                    value={extendDeactivationObj?.updateReason}
                    onChange={(e) => {
                      setExtendDeactivationObj({
                        ...extendDeactivationObj,
                        updateReason: e.target.value,
                      });
                    }}
                  />
                </Fragment>
              )}
            </div>
          </Fragment>
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(0, extendDeactivationObj?.index),
                        {
                          ...data[extendDeactivationObj?.index],
                          extend_deactivation:
                            !data[extendDeactivationObj?.index]
                              ?.extend_deactivation,
                        },
                        ...data.slice(extendDeactivationObj?.index + 1),
                      ]);
                      setExtendDeactivationObj({
                        index: 0,
                        loyaltyDetails: {},
                        modal: false,
                        updateReason: "",
                        otherReason: false,
                        extendDeactiveDate: moment(new Date()).format(
                          "YYYY-MM-DD"
                        ),
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                      if (
                        extendDeactivationObj?.extendDeactiveDate ===
                        "Invalid date"
                      ) {
                        toast.dismiss();
                        return toast.error("Invalid Deactivation Date", {
                          toastId: "invalid-deactive-extended-date-error",
                        });
                      }
                      if (!extendDeactivationObj?.updateReason) {
                        return toast.error("Please fill the reason", {
                          toastId: "empty-reason",
                        });
                      }
                      handleExtendDeactiveDate();
                    }}
                  >
                    Update
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>

      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            History{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
                "Reason Code",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${
                    d?.["User.email"]
                      ? d?.["User.email"]
                      : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                        d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                  d?.reason,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
      <CSVLink
        id="csv"
        data={exportData}
        headers={exportHeaders.map((head) => head)}
        filename={
          `UnconsentedMemberAccounts` +
          " " +
          moment(new Date()).format("MM-DD-YYYY,h:mm A") +
          ".csv"
        }
      />
    </Fragment>
  );
}